import styled from 'styled-components'

const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-center: center;

  padding: 16px 0 24px;
`;

export default Logo;